import React from 'react';

import { StoryblokComponent, storyblokEditable } from '@storyblok/react';

const WunderElement = ({ blok }) => {
  return <div>{blok.title}</div>;
};

export default WunderElement;
